import { User } from '../../../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../../../models/interfaces/BusinessObject.interface';
import CategoryTableComponent from '../../components/category-table/category-table.component';
import { Link, useOutletContext } from 'react-router-dom';
import React from 'react';
import routeService from '../../../../../../routes/route.service';

export default function CategoryListComponent() {
  const { user, businessObject } = useOutletContext<{ user: User; businessObject: BusinessObject }>();

  return (
    <div>
      <CategoryTableComponent
        userId={user?.id}
        businessObjectId={businessObject?.id}
        categories={businessObject?.categories}
      ></CategoryTableComponent>

      <div>
        <Link to={`${routeService.getAndFillBusinessObjectDetailPath(user?.id, businessObject?.id)}`}>
          Back to business object detail
        </Link>
      </div>
    </div>
  );
}
